module.exports = __webpack_public_path__ + "static/community-young-leader-photo-20469a13ee8c5781c333f60d9478fb4e.jpg";